import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine, { DimensionLineType } from "../Lines/DimensionLine";

export class Rectangle extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'rectangle', dimensions );

		this.labelMappings = {
			length: 'width',
			width: 'height',
		};
	}

	getLength(): Length {
		return this.cleanedPrimitives.length;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getHeight(): Length {
		return this.cleanedPrimitives.length;
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'width', secondary: 'length' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [0, 0], [ 0, this.getWidth().in_mm() ], this.renderDimensionLabel( 'height' ), [-40, 0], ratio, this.getDimensionLineType('measurements-rectangle-width', focusedElement, forceRender) ), // Vertical line
				new DimensionLine( [0, 0], [ this.getLength().in_mm(), 0 ], this.renderDimensionLabel( 'width' ), [0, -40], ratio, this.getDimensionLineType('measurements-rectangle-length', focusedElement, forceRender ) ), // Horizontal line
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			width: 50,
			length: 50,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			width: height.divide(2).in_cm(),
			length: width.divide(2).in_cm(),
		};
	}
}
